/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Confirmations_Not_IssuableInputs */

const en_error_order_confirmations_not_issuable = /** @type {(inputs: Error_Order_Confirmations_Not_IssuableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no order to confirm, or an order chosen cannot be confirmed.`)
};

/**
* | output |
* | --- |
* | "There is no order to confirm, or an order chosen cannot be confirmed." |
*
* @param {Error_Order_Confirmations_Not_IssuableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_order_confirmations_not_issuable = /** @type {((inputs?: Error_Order_Confirmations_Not_IssuableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Confirmations_Not_IssuableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_order_confirmations_not_issuable(inputs)
});